import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

class Checkbox extends Component {
  onKeyDown = e => {
    const { onToggle } = this.props;

    if (e.key === ' ') onToggle();
  };

  onClick = () => {
    const { disabled, onToggle } = this.props;

    if (!disabled) onToggle();
  };

  render() {
    const { id, size, checked, disabled } = this.props;

    return (
      <StyledContainer
        id={id ? `ui-wrapper-for-${id}` : null}
        size={size}
        tabIndex={disabled ? null : 0}
        onKeyDown={this.onKeyDown}
      >
        <StyledHiddenCheckbox
          id={id}
          checked={checked}
          disabled={disabled}
          readOnly={true}
          onClick={this.onClick}
        />
        <StyledBox
          size={size}
          onClick={this.onClick}
          checked={checked}
          disabled={disabled}
        >
          {checked && (
            <StyledCheckmark
              size={size}
              checked={checked}
              disabled={disabled}
            />
          )}
        </StyledBox>
      </StyledContainer>
    );
  }
}

Checkbox.defaultProps = {
  size: 'medium',
  disabled: false,
};

export default Checkbox;

const Checkmark = props => (
  <svg {...props} viewBox="0 0 240 170">
    <polyline
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="10 95 85 170 230 15"
    />
  </svg>
);

const StyledContainer = styled.span`
  #certiself-form & {
    box-sizing: border-box;
    & * {
      box-sizing: border-box;
    }

    display: inline-block;
    outline: none;

    // We need some room for the checkmark, which sticks outside the box
    margin-right: 18px;
  }
`;

const StyledHiddenCheckbox = styled.input.attrs(props => ({
  type: 'checkbox',
}))`
  display: none;
`;

const StyledBox = styled.div`
  width: ${props => getBoxSize(props)};
  height: ${props => getBoxSize(props)};

  border: 1px solid #d9d9d9;
  border-radius: 5px;

  background: ${props => getBoxBackground(props)};

  ${StyledContainer}:focus > & {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.075);
  }
`;

const checkAnim = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

const StyledCheckmark = styled(Checkmark)`
  position: absolute;
  & * {
    vector-effect: non-scaling-stroke;
  }
  width: ${({ size }) => (size === 'small' ? '18px' : '24px')};
  height: ${({ size }) => (size === 'small' ? '14px' : '17px')};
  transform: translate(3px, -2px);
  pointer-events: none;

  stroke: ${({ disabled }) => (disabled ? '#ccc' : '#363636')};

  & polyline {
    stroke-dasharray: 40px;
    stroke-dashoffset: 40px;
    animation: ${checkAnim} 100ms ease-out forwards;
    stroke-width: ${({ size }) => (size === 'small' ? '1.5px' : '2px')};
  }
`;

const getBoxSize = props => {
  const { size } = props;
  if (size === 'small') return '16px';

  // Medium
  return '20px';
};

const getBoxBackground = props => {
  const { checked, disabled } = props;

  if (checked || disabled) return '#EFEFEF';
  return 'white';
};
